import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Tabs from "./tabs/Tabs";
import data from "./data.json";

const TableData = () => {
  let [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  let tableBodyArray = [];
  let tableBody = "";
  for (let i = 0; i < 17; i++) {
    tableBody = (
      <tr className="text-right truncate" key={i}>
        <td className="flex items-center px-5 py-3">
          {/* <div className="rounded-full bg-tableColor w-10 h-10"></div> */}
          <div className="inline-block ml-2">
            <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
              {/* {data.person1.asset_name.name} */}
            </div>
            <div className="text-bodyColor text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
              {/* {data.person1.asset_name.value} */}
            </div>
          </div>
        </td>
        <td className="px-5 text-bodyColor text-base font-Inter font-semibold break-words">
          {/* <div className="mx-1.5">{data.person1.LTV}</div> */}
        </td>
        <td className="px-5 text-submitButtonColor text-base font-Inter font-semibold break-words">
          {/* <div className="mx-1.5">{data.person1.deposit_apy}</div> */}
        </td>
        <td className="px-5">
          <div className="inline-block ml-2 mr-0.5">
            <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
              {/* {data.person1.market_size.name} */}
            </div>
            <div className="text-bodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
              {/* {data.person1.market_size.value} */}
            </div>
          </div>
        </td>
        <td className="px-5 text-submitButtonColor text-base font-Inter font-semibold break-words">
          {/* <div className="mx-1.5">{data.person1.borrow_apy}</div> */}
        </td>
        <td className="px-5">
          <div className="inline-block ml-2 mr-1.5">
            <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
              {/* {data.person1.total_borrowed.name} */}
            </div>
            <div className="text-bodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
              {/* {data.person1.total_borrowed.value} */}
            </div>
          </div>
        </td>
        <td className="px-5">
          <div className="inline-block ml-2 mr-1.5">
            <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
              {/* {data.person1.wallet.name} */}
            </div>
            <div className="text-bodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
              {/* {data.person1.wallet.value} */}
            </div>
          </div>
        </td>
      </tr>
    );
    tableBodyArray.push(tableBody);
  }

  return (
    <div className="m-5 xl:m-7 shadow-md shadow-tableColor">
      <div className="w-full bg-tableColor rounded-t-md rounded-r-md px-5 py-4 text-bodyColor text-lg font-Inter font-bold break-words">
        Assets
      </div>
      <div className="px-5 py-6 bg-tableBodyColor" data-te-input-init>
        <label className="relative block">
          <span className="sr-only">Search</span>
          <span className="absolute inset-y-0 left-0 flex items-center pl-4 text-bodyColor text-opacity-60">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-3 h-3"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
              />
            </svg>
          </span>
          <input
            className="w-1/2 h-11 px-9 border bg-tableBodyColor text-opaBodyColor border-bodyColor border-solid border-opacity-20 rounded-lg placeholder:text-bodyColor placeholder:text-opacity-60 placeholder:text-sm placeholder:font-Inter placeholder:font-medium placeholder:break-words outline-none"
            placeholder="Search token"
          />
        </label>
      </div>
      <div className="overflow-x-auto ">
        <table className="w-full text-sm font-light bg-tableBodyColor">
          <thead>
            <tr>
              <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
                <span className="flex items-center">
                  Asset Name
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
              <th className="p-5 text-bodyColor text-base font-Outfit font-semibold break-words">
                <span className="flex items-center justify-end">
                  LTV
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
              <th className="p-5 text-bodyColor text-opacity-60 text-base font-Outfit font-semibold break-words">
                <span className="flex items-center justify-end">
                  Deposit APY
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
              <th className="p-5 text-bodyColor text-opacity-60 text-base font-Outfit font-semibold break-words">
                <span className="flex items-center justify-end">
                  Market Size
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
              <th className="p-5 text-bodyColor text-opacity-60 text-base font-Outfit font-semibold break-words">
                <span className="flex items-center justify-end">
                  Borrow APY
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
              <th className="p-5 text-bodyColor text-opacity-60 text-base font-Outfit font-semibold break-words">
                <span className="flex items-center justify-end">
                  Total Borrowed
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
              <th className="p-5 text-bodyColor text-opacity-60 text-base font-Outfit font-semibold break-words">
                <span className="flex items-center justify-end">
                  Wallet
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-6 h-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
                    />
                  </svg>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-right truncate" onClick={openModal}>
              <td className="flex items-center px-5 py-3">
                <div className="rounded-full bg-tableColor w-10 h-10"></div>
                <div className="inline-block ml-2">
                  <div className="text-bodyColor text-left text-lg font-Inter font-semibold break-words">
                    {data.person1.asset_name.name}
                  </div>
                  <div className="text-bodyColor text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
                    {data.person1.asset_name.value}
                  </div>
                </div>
              </td>
              <td className="px-5 text-bodyColor text-base font-Inter font-semibold break-words">
                <div className="mx-1.5">{data.person1.LTV}</div>
              </td>
              <td className="px-5 text-submitButtonColor text-base font-Inter font-semibold break-words">
                <div className="mx-1.5">{data.person1.deposit_apy}</div>
              </td>
              <td className="px-5">
                <div className="inline-block ml-2 mr-0.5">
                  <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
                    {data.person1.market_size.name}
                  </div>
                  <div className="text-bodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
                    {data.person1.market_size.value}
                  </div>
                </div>
              </td>
              <td className="px-5 text-submitButtonColor text-base font-Inter font-semibold break-words">
                <div className="mx-1.5">{data.person1.borrow_apy}</div>
              </td>
              <td className="px-5">
                <div className="inline-block ml-2 mr-1.5">
                  <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
                    {data.person1.total_borrowed.name}
                  </div>
                  <div className="text-bodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
                    {data.person1.total_borrowed.value}
                  </div>
                </div>
              </td>
              <td className="px-5">
                <div className="inline-block ml-2 mr-1.5">
                  <div className="text-bodyColor text-lg font-Inter font-semibold break-words">
                    {data.person1.wallet.name}
                  </div>
                  <div className="text-bodyColor text-right text-opacity-60 text-sm font-Inter font-semibold break-words mt-1">
                    {data.person1.wallet.value}
                  </div>
                </div>
              </td>
            </tr>
            {tableBodyArray}
          </tbody>
        </table>
      </div>

      {/* BTC Modal */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-backdropBlurColor backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-modalWidth transform overflow-hidden rounded-lg bg-tableBodyColor text-left align-middle shadow-xl transition-all">
                  {/* Modal Title */}
                  <Dialog.Title
                    as="div"
                    className="w-full h-modalHeight flex justify-between items-center bg-tableColor p-7 text-bodyColor font-Inter text-2xl not-italic font-bold leading-normal"
                  >
                    BTC
                    <button type="button" onClick={closeModal}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={2}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </Dialog.Title>

                  {/* Modal Body */}
                  <Tabs />

                  {/* Modal Footer */}
                  <div className="px-7">
                    <button
                      type="button"
                      className="inline-flex justify-center items-center w-full h-modalButtonHeight py-4 bg-submitButtonColor text-white rounded-lg text-center font-Inter text-lg not-italic font-semibold leading-normal"
                      onClick={closeModal}
                    >
                      Please input a valid number
                    </button>
                  </div>
                  <div className="flex justify-center">
                    <label
                      htmlFor="info"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    ></label>
                    <select
                      id="info"
                      name="info"
                      className="flex items-center w-24 py-6 rounded-md border-0 bg-tableBodyColor text-bodyColor focus:outline-none"
                      defaultValue="More Info"
                    >
                      <option>More Info</option>
                    </select>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default TableData;
